import { render, staticRenderFns } from "./AdminManagementLog.vue?vue&type=template&id=20a9fd8d&scoped=true&"
import script from "./AdminManagementLog.vue?vue&type=script&lang=js&"
export * from "./AdminManagementLog.vue?vue&type=script&lang=js&"
import style0 from "./AdminManagementLog.vue?vue&type=style&index=0&id=20a9fd8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9fd8d",
  null
  
)

export default component.exports